const riot = require('riot');

riot.tag2('module-event-list', '<div class="f fclm s-full rounded-8 elevation-default-low bg-white"> <div class="pt32 px32 pb28"> <div class="mb8" data-is="module-section-header" title="{opts.distributionTargetStrategy.distribution_target_type === &quot;raffle&quot; ? &quot;抽選対象一覧&quot; : &quot;配布対象イベント一覧&quot;}"> <yield to="right"> <div class="f fm" if="{parent.opts.distributionRule.status === &quot;published&quot; &amp;&amp; !parent.opts.distributionRule.archived_at}"><i class="icon-refresh fs24 text-gray_60 cursor-pointer mr14" onclick="{parent.onDebounceRefreshEvents}"></i> <button class="button primary mr8" type="button" onclick="{parent.onOpenImportPopup}" disabled="{parent.opts.disabled}"><i class="icon-cloud-upload text-white_70 fs20 mr4"></i> <div class="mr4">イベント発行</div><i class="icon-cheveron-down fs20 text-white_70"></i> </button> <button class="button primary" type="button" onclick="{parent.onOpenExportPopup}" disabled="{!parent.pagination || parent.pagination.total == 0}"><i class="icon-cloud-upload text-white_70 fs20 mr4"></i> <div class="mr4">CSVのエクスポート</div><i class="icon-cheveron-down fs20 text-white_70"></i> </button> </div> </yield> </div> <div class="text-red_90 ts-pxs mb8" if="{opts.disabled}">残高が当選予定金額より不足しているためCSVファイルのインポートが行えません。担当にご連絡及びご入金をお願いします。</div> <div class="text-gray_60 ts-pxs">CSVのインポートとエクスポートは数分待ってから、再読み込みすると下に結果が反映されます。<br>エクスポートに成功したものをダウンロードできます。</div> <div class="word-break-all text-navy ts-pm mb24 mt16">対象イベント数: {pagination.total.toLocaleString()} 件</div> </div> <div class="f fclm"> <div class="max-height-500" data-is="module-table" schemas="{tableSchemas}" items="{events}" scroll-type="y"></div> <div class="f fr mta mr32"> <div ref="pagination" data-is="atom-pagination" pagination="{pagination}"></div> </div> </div> </div>', 'module-event-list,[data-is="module-event-list"]{display:block}', '', function(opts) {
    this.on('mount', async () => {

      this.input = document.createElement('input');
      this.input.type = 'file';
      this.input.accept = 'text/csv';
      this.input.multiple = true;

      this.input.onchange = async (e) => {
        var file = e.currentTarget.files[0];
        if (!file) return ;
        this.input.value = '';
        await this.handleCSV({ file })
          .then(() => this.opts.onStartImportJob());
        this.update();
      };

      if (this.opts.distributionTargetStrategy.distribution_target_type === "raffle") {
        this.tableSchemas = [
          {
            id: 'conversion_at',
            label: 'コンバージョン日時(JST)',
            class: 'w220 flex-fixed',
            getText: (v) => dayjs(v).format('YYYY-MM-DD HH:mm:ss'),
          },
          {
            id: 'service_uid',
            label: 'ユーザーID',
            class: 'min-width-220 w0 flex-auto',
          },
          {
            id: 'created_at',
            label: 'OneTimeURL発行日時(JST)',
            class: 'w220 flex-fixed',
            getText: (v) => dayjs(v).format('YYYY-MM-DD HH:mm:ss'),
          },
          {
            id: 'menu',
            component: 'material-icon-button',
            text: 'more_vert',
            align: 'center',
            class: 'flex-fixed w52',
            onclick: (rule, e) => {
              this.openRulesMenu(rule, e);
            },
          },
        ];
      }
      else {
        this.tableSchemas = [
          {
            id: 'conversion_at',
            label: 'コンバージョン日時(JST)',
            class: 'w220 flex-fixed',
            getText: (v) => dayjs(v).format('YYYY-MM-DD HH:mm:ss'),
          },
          {
            id: 'service_uid',
            label: 'ユーザーID',
            class: 'min-width-220 w0 flex-auto',
          },
          {
            id: 'distribution_point',
            label: '付与ポイント額',
            class: 'w220 flex-fixed',
            align: 'right',
            getText: (v) => v.distribution_point_amount.toLocaleString(),
          },
          {
            id: 'created_at',
            label: 'OneTimeURL発行日時(JST)',
            class: 'w220 flex-fixed',
            getText: (v) => dayjs(v).format('YYYY-MM-DD HH:mm:ss'),
          },
          {
            id: 'menu',
            component: 'material-icon-button',
            text: 'more_vert',
            align: 'center',
            class: 'flex-fixed w52',
            onclick: (rule, e) => {
              this.openRulesMenu(rule, e);
            },
          },
        ];
      }
      try {
        await this.fetchEvents();
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message)
      }

      this.refs.pagination.on('paginationchange', async (offset_type) => {
        var indicator = spat.modal.indicator();
        var offset = this.pagination[offset_type];
        try {
          await this.fetchEvents(offset);
        }
        catch (e) {
          console.error(e);
          spat.modal.alert(e.message)
        }
        finally {
          indicator.close();
        }
      });
    });

    this.fetchEvents = async (offset=0) => {
      var company_id = this.opts.distributionRule.company.id;
      var project_id = this.opts.distributionRule.project.id;

      var query = {
        offset,
        limit: 50,
        distribution_rule_id: this.opts.distributionRule.id,
      };

      if (this.opts.distributionTargetStrategy.distribution_target_type === "raffle") {
        query.raffle_rule_id = this.opts.raffleRule.id;
        var { raffle_events: events, pagination } = await app.api.child(`companies/${company_id}/projects/${project_id}/raffle_events`).get(query);
      }

      else {
        var { distribution_events: events, pagination } = await app.api.child(`companies/${company_id}/projects/${project_id}/distribution_events`).get(query);
      }
      this.events = events;
      this.pagination = pagination;
      this.update();
    };

    this.onDebounceRefreshEvents = _.debounce(() => {
      this.refreshEvents();
    }, 1000, true);

    this.refreshEvents = async () => {
      var indicator = spat.modal.indicator();
      try {
        await this.fetchEvents();
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.handleCSV = async ({ file, isCreateEvent=false, count=0, amount=0 }) => {

      var csv_data = [];
      var stream = csv();
      let headers = [];
      stream.on('headers', (stream_headers) => {
        headers = stream_headers;
      });
      stream.on('data', (data) => {
        csv_data.push(data);
      });
      var readFile = (file) => {
        var reader = new FileReader;
        return new Promise(resolve => {
          reader.onload = (e) => {
            stream.write(e.target.result);
            resolve();
          };
          reader.readAsText(file);
        });
      };
      var per = 100;
      var i = 0;
      while (csv_data.length < 10 && i * per < file.size) {
        var slice_file = file.slice(i * per, (i + 1) * per);
        await readFile(slice_file);
        i++;
      }
      stream.end();

      csv_data = csv_data.slice(0, 10);

      const invalid = this.validateCSV(headers, csv_data);
      if (invalid) {
        spat.modal.open('modal-invalid-message', {
          title: this.invalidTypeToText(invalid.type),
          data: invalid.data,
          message: invalid.message,
        });
        return ;
      }

      var modal = spat.modal.open('modal-csv-preview', {
        headers,
        items: csv_data,
        dismissible: false,
        isRaffle: this.opts.distributionTargetStrategy.distribution_target_type === "raffle",

        isCreateEvent,
        pointProviderSelectionEnabled: this.opts.distributionRule.point_provider_selection_enabled,
        count,
        amount,
      });
      var result = await modal.waitClose();
      if (!result) return ;

      await this.uploadFile(file);
    };

    this.validateCSV = (headers, rows) => {

      let required_headers = [
        'service_uid',
        'conversion_at',
      ];

      if (this.opts.distributionTargetStrategy.distribution_target_type !== "raffle" && !this.opts.distributionRule.point_provider_selection_enabled) {
        required_headers.push('distribution_point_amount', 'point_provider');
      }

      const not_found_headers = required_headers.filter(header => !headers.includes(header));

      if (not_found_headers.length) {
        return {
          code: 'required_header_not_found',
          type: 'shortage',
          data: `不足しているヘッダー: ${not_found_headers.join(', ')}`,
          message: `CSVヘッダーが不足しています。`,
        };
      }

      if (!rows || !rows.length) {
        return {
          code: 'no_data',
          type: 'shortage',
          message: 'データが1行もありません。'
        };
      }

      const formats = {

        service_uid: {
          type: 'string',
          required: true,
          minlength: 1,
          maxlength: 300,
        },
        conversion_at: {
          type: 'date',
          required: true,
        },

        distribution_point_amount: {
          type: 'int',
          required: true,
          min: 1,
          max: 999999999,
        },

        point_provider: {
          type: 'string',
          required: true,
          values: app.data.constants.point_providers.map(p => p.id),
        },

        option_email: {
          type: 'string',
          required: false,
        },
      };

      for (let i = 0; i < rows.length; ++i) {
        const { isValid, target } = app.utils.validator.validate(rows[i], formats);
        if (!isValid) {
          return {
            code: 'invalid_data',
            type: target.type || 'invalid',

            data: `行: ${i + 2}\n${target.key} : ${target.item}`,
            message: target.message,
          };
        }
      }

      return false;
    };

    this.invalidTypeToText = (type) => {
      return {
        invalid: '不正な値があります。',
        shortage: '必要な情報が不足しています。',
      }[type] || 'エラーが発生しました。';
    };

    this.onImport = (e) => {
      e.preventDefault();
      this.input.click();
    };

    this.onOpenImportPopup = (e) => {
      e.preventDefault();
      e.stopPropagation();
      var options = [
        {
          label: 'CSVインポート',
          action: () => {
            popup.close();
            this.onImport(e);
          },
        },
        {
          label: '発行数を入力',
          action: async () => {
            popup.close();
            var modal = await spat.modal.open('modal-create-event', {
              distribution_target_type: this.opts.distributionTargetStrategy.distribution_target_type,
              point_providers: this.opts.distributionRule.distribution_point_strategies.map(s => s.point_provider),
            });
            var result = await modal.waitClose();

            if (!result) return ;
            let file = this.createCSV(result.count, result.amount);
            modal.close();
            await this.handleCSV({ file, isCreateEvent: true, count: result.count, amount: result.amount })
              .then(() => this.opts.onStartImportJob());
          },
        },
      ];

      var popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 8,
        position: 'bottom',
        align: { x: 'right' },
        opts: {
          options,
        }
      });
    };

    this.uploadFile = async (file) => {
      var indicator = spat.modal.indicator();

      var company_id = this.opts.distributionRule.company.id;
      var project_id = this.opts.distributionRule.project.id;
      var campaign_id = this.opts.distributionRule.campaign.id;

      try {
        if (this.opts.distributionTargetStrategy.distribution_target_type === "raffle") {

          var {signed_url} = await app.api.child(`companies/${company_id}/projects/${project_id}/raffle_events/signed_url`).post({
            campaign_id,
            distribution_rule_id: this.opts.distributionRule.id,
            raffle_rule_id: this.opts.raffleRule.id,
          });
        }
        else {

          var {signed_url} = await app.api.child(`companies/${company_id}/projects/${project_id}/distribution_events/signed_url`).post({
            campaign_id,
            distribution_rule_id: this.opts.distributionRule.id,
            distribution_target_strategy_id: this.opts.distributionTargetStrategy.id,
          });
        }
        try {
          await fetch(signed_url, {
            method: "PUT",
            headers: {
              "Content-Type": 'text/csv',
            },
            body: file
          });
          spat.toast.message('CSVインポートが開始されました');
        }
        catch(e) {
          spat.modal.alert(e.stack, 'CSVインポートでエラーが発生しました。');
          Sentry.captureException(e);
        }
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.export = async (format_type) => {
      var indicator = spat.modal.indicator();

      var target_type = "onetime_hashes";
      var query = {
        campaign_id: this.opts.distributionRule.campaign.id,
        distribution_rule_id: this.opts.distributionRule.id,
        format_type,
      };

      var company_id = this.opts.distributionRule.company.id;
      var project_id = this.opts.distributionRule.project.id;

      if (this.opts.distributionTargetStrategy.distribution_target_type === "raffle") {
        target_type = "raffle_onetime_hashes"
        query.raffle_rule_id = this.opts.raffleRule.id
      }
      try {
        await app.api.child(`companies/${company_id}/projects/${project_id}/${target_type}/export_csv`).post(query);
        spat.toast.message('エクスポートが開始されました');
        this.opts.onStartExportJob();
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.onOpenExportPopup = (e) => {
      e.preventDefault();
      e.stopPropagation();
      var options = app.data.constants.onetime_hash_export_job_format_types.map((type) => {
        return {
          label: type.name,
          action: () => {
            popup.close();
            this.export(type.id);
          },
        };
      });

      var popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 8,
        position: 'bottom',
        align: { x: 'right' },
        opts: {
          options,
        }
      });
    };

    this.openRulesMenu = (rule, e) => {
      e.preventDefault();
      e.stopPropagation();
      var type = this.opts.distributionTargetStrategy.distribution_target_type === "raffle" ? "raffle" : "gift";
      const url = `${spat.config.end_user_domain}/${type}?hash=${rule.onetime_hash}`;
      var options = [
        {
          icon: "clipboard-copy",
          label: "OneTimeURLをコピー",
          action: () => {
            popup.close();
            app.utils.copyToClipBoard(url);
            spat.toast.message('コピーしました');
          },
        },
      ];

      var popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 8,
        align: {x: 'right'},
        position: 'bottom',
        opts: {
          options,
        }
      });
    };

    this.createCSV = (count, amount) => {

      let header = "";
      if (this.opts.distributionTargetStrategy.distribution_target_type === "raffle") {
        header = "service_uid,conversion_at\n";
      }
      else if (this.opts.distributionTargetStrategy.distribution_target_type === "all") {
        header = "service_uid,distribution_point_amount,point_provider,conversion_at\n";
      }

      let csvContent = header;

      const now = dayjs();

      var indicator = spat.modal.indicator();
      try {

        for (let i = 1; i <= count; i++) {

          const serviceUid = i;

          if (this.opts.distributionTargetStrategy.distribution_target_type === "raffle") {
            csvContent += `${serviceUid},${now.toISOString()}\n`;
          }
          else if (this.opts.distributionTargetStrategy.distribution_target_type === "all") {
            csvContent += `${serviceUid},${amount},${this.opts.distributionPointStrategy},${now.toISOString()}\n`;
          }
        }

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        return blob;
      }
      catch (e) {
        console.error('Blobの生成でエラーが発生しました', e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    }
});